export default __webpack_public_path__ + "static/media/asqs-logo.ecbfbbf8.png";